






























helpers = require('../../helpers.coffee')

view_model =
  components:
    tag: require('./tag')
    colorInput: require('./color_input')

  props: ['tag', 'options']

  data: ->
    name: @tag.name
    color: @tag.color
    selected: false
    editing: false
    default_options:
      can_edit: true
      checkbox: true

  methods:
    submit: ->
      @$validator.validateAll({@name}).then (success) =>
        @updateTag() if success

    updateTag: ->
      Loader.on()
      params = {id: @tag.id, @name, @color}
      new TagsResource().update(@updateTagSuccess, @handleApiErrors, params)

    updateTagSuccess: (data) ->
      Loader.off()
      alertify.success 'Salvo com sucesso'
      @editing = false
      @$emit('updated', data.tag)

    destroyTag: ->
      @$emit('destroy', @tag)

    toggleSelected: ->
      @selected = !@selected
      @$emit('selection-toggle', tag: @tag, selected: @selected)

    mergeDefaultOptions: ->
      @default_options = Object.assign({}, @default_options, @options || {})

  watch:
    tag: ->
      @selected = false

  created: ->
    @mergeDefaultOptions()

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/tags/list_item.vue